<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Prioritas Nasional</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-6">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-6">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="text-center" style="width: 5%">No.</th>
                                    <th class="text-center" style="width: 10%">No Prioritas</th>
                                    <th class="text-center" style="width: 35%">Bidang Prioritas</th>
                                    <th class="text-center" style="width: 40%">Prioritas Pembangunan</th>

                                    <th class="text-center" style="width: 10%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.rkpd_prioritas_nasional_id">
                                    <td class="tabel_center text-center">{{index+1}}.</td>
                                    <td class="tabel_center text-center" >{{data.nomor_prioritas_nasional}}</td>
                                    <td class="tabel_center">{{data.bidang_prioritas_nasional}}</td>
                                    <td class="tabel_center" >{{data.uraian_prioritas_nasional}}</td>
                                    <td class="tabel_center text-center" >

                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.rkpd_prioritas_nasional_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>

                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RPJMD TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">


                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">No Prioritas</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.nomor_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Bidang Prioritas</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.bidang_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Prioritas Nasional</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.uraian_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Tema Program</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.tema_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    



                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">No Prioritas</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.nomor_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Bidang Prioritas</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.bidang_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Prioritas Nasional</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.uraian_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Tema Program</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="form.tema_prioritas_nasional" type="text" class="form-control">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                


                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>

<script>

    const ADD_URL = URL_APP+'api/v1/planning_rkpd_prioritas_nasional/';


    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    rkpd_prioritas_nasional_id : '',
                    tahun : '',
                    nomor_prioritas_nasional : '',
                    bidang_prioritas_nasional : '',
                    uraian_prioritas_nasional : '',
                    tema_prioritas_nasional : '',
                    unit_kerja : '',
                },

                unit_kerja : '',
                unit_kerja_full : '',


                check_data_add : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            this.form.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();
            this.getDataTahun();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.form.unit_kerja,
                      tahun : this.form.tahun
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){

            },
            selectData : function(data){
                this.form = {
                    rkpd_prioritas_nasional_id : data.rkpd_prioritas_nasional_id,
                    tahun : data.tahun,
                    nomor_prioritas_nasional : data.nomor_prioritas_nasional,
                    bidang_prioritas_nasional : data.bidang_prioritas_nasional,
                    uraian_prioritas_nasional : data.uraian_prioritas_nasional,
                    tema_prioritas_nasional : data.tema_prioritas_nasional,
                    unit_kerja : data.unit_kerja,
                };

                this.getDataTahun();
            },

        //TAMBAHAN
           


        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;
                this.getData();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            btn_check_data_add : function(){
                // this.getDataTahun();
                if (this.form.tahun != '') {
                    this.check_data_add = true;
                }else{
                    this.check_data_add = false;
                }
            },
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    // console.log(res_data);
                    this.form.tahun = this.getTgl().tahun
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>